import React from 'react'
import PropTypes from 'prop-types'

import styles from './TableExpand.css'

const propTypes = {
    children: PropTypes.node.isRequired,
}

const TableExpand = ({ children }) => (
    <div className={styles.trExpansion}>
        <div className={styles.trExpansionCondition} />
        <div className={styles.trExpansionInner}>
            {children}
        </div>
    </div>
)

TableExpand.propTypes = propTypes

export default TableExpand



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/Table/TableExpand/TableExpand.jsx